import { render, staticRenderFns } from "./System-serverip.vue?vue&type=template&id=2b5a34f7&scoped=true&"
import script from "./System-serverip.vue?vue&type=script&lang=js&"
export * from "./System-serverip.vue?vue&type=script&lang=js&"
import style0 from "./System-serverip.vue?vue&type=style&index=0&id=2b5a34f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a34f7",
  null
  
)

export default component.exports